<script>
  import { createEventDispatcher, onMount } from 'svelte'
  import { sparePartsAPI } from './api'
  import AddToCart from './AddToCart.svelte'
  import { Icon, Switch } from 'smelte'

  export let filtered = []
  export let spareParts = []
  export let project = 'N/A'

  const dispatch = createEventDispatcher()
  const api = new sparePartsAPI()
  const imgURL = 'http://repl.flexlink.com/os/downloadimage.htm?type=thumbzoom&name='

  let openSections = []
  let expandedItem = null
  let selectAll = false
  let _selectAll = null

  $: onSelectAllChange(selectAll)

  onMount(async () => {
    await sleep(500)
    for (let i = 0; i < filtered.length; i++) {
      showDetailsHandler(filtered[i])
      await sleep(200)
    }
  })

  function sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  function onSelectAllChange (selectAll) {
    if (_selectAll != null) {
      for (let i = 0; i < spareParts.length; i++) {
        spareParts[i].value = selectAll
      }
      _selectAll = selectAll
      return
    }
    _selectAll = selectAll
  }

  function showDetailsHandler (item) {
    const article = item.ProductNo
    const cfid = item.Cfid
    // console.log('[DEBUG] cfid:', cfid, 'product:', article)
    openSections = [...openSections.filter(s => s !== article + cfid), article + cfid]
    console.log('[DEBUG] open sections', openSections)
    if (!!spareParts.find(s => s.parent === article + cfid)) {
      console.log('[DEBUG] no new spare parts -> return')
      return
    }
    api.getParts(article, cfid)
      .then(res => {
        console.log('[DEBUG] received spare parts', res)
        const collection = res.map(p => {
          // TODO: define quantity?!
          return {...p, parent: article + cfid, quantity: 1}
        })
        spareParts = [...spareParts, ...collection]
      })
      .catch(err => {
        console.log('[ERROR] fetch project spare parts', err)
      })
    expandedItem = item
  }

  function hideDetailsHandler (item) {
    const article = item.ProductNo
    const cfid = item.Cfid
    openSections = [...openSections.filter(s => s !== article + cfid)]
  }
</script>

<div class="py-8 px-2 list">
  <div class="text-right pr-4">
    <Switch label="Add all spare parts to cart"
            color="red"
            class="cart-switch"
            bind:value={selectAll} />
  </div>

  {#if filtered.length < 1}
    <div class="py-20">
      <span class="text-xl font-light text-gray-400">No products found in <strong>{project}</strong> project</span>
    </div>
  {/if}

  {#if filtered.length > 0}

    <!--
      PRODUCTS HEADER =================================================================================================
    -->
    <div class="hidden md:block w-full mt-2">
      <div class="h-12 flex items-center pl-10 text-white bg-gray-600 text-base text-left row">
        <div class="mr-6" style="width: 20px; height: 20px;">
          &nbsp
        </div>
        <div class="flex w-full mr-12">
          <div class="w-1/5">PRODUCT NUMBER</div>
          <div class="w-32 pr-6">QUANTITY</div>
          <div class="flex-grow">PRODUCT NAME</div>
        </div>
      </div>
    </div>

    {#each filtered as p, i}
      <div class="w-full my-2 shadow">

        <div class="md:h-16 flex flex-wrap md:flex-nowrap items-center text-lg pl-10
                    text-gray-900 bg-gray-50 border-b-2 border-gray-300 row">

          <div class="bg-white mr-6 thumb" style="width: 20px; height: 20px;">
            <img src={imgURL + p.ThumbName} class="object-contain" />
          </div>
          <div class="bg-white h-56 w-56 hide">
            <img src={imgURL + p.ThumbNameZoom} class="object-contain" />
          </div>


          <div class="flex flex-wrap md:flex-nowrap items-center w-full mr-12">

            <div class="w-2/3 md:w-1/5 pt-4 pb-4 font-bold text-left text-gray-700">{p.ProductNo}</div>

            <div class="w-32 text-base text-center font-light pr-6">{p.SumQty} pcs</div>

            <div class="flex-grow text-base text-left font-light">
              {p.Name}
              <div>{p.Cfid !== "" ? p.Description : ''}</div>
            </div>

            <!--
            <div class="w-1/4 text-base text-left font-light">{p.Description}</div>
            -->

            <div class="w-full px-5 pt-3 pb-4 flex-shrink-0 text-base font-light rounded-2
                      md:w-auto">
              <AddToCart sp={({value: false, quantity: 1, parent: 'p_' + p.ProductNo, SparePartNo: p.ProductNo})}
                         on:change={(e) => { dispatch('add_to_cart', e.detail) }}
              />
            </div>

          </div>

          <div class="absolute top-0 right-0 py-4 w-16">
            {#if openSections.indexOf(p.ProductNo + p.Cfid) > -1}
              <div class="flex-shrink-0 cursor-pointer" on:click={() => hideDetailsHandler(p)}>
                <Icon>remove_circle_outline</Icon>
              </div>
            {:else if p.SpCount > 0 }
              <div class="flex-shrink-0 cursor-pointer" on:click={() => showDetailsHandler(p)}>
                <Icon>add_circle_outline</Icon>
              </div>
            {:else}
              &nbsp;
            {/if}
          </div>
        </div>

        <!--
          SPARE PARTS =================================================================================================
        -->
        {#if openSections.indexOf(p.ProductNo + p.Cfid) > -1}
          <div class="bg-gray-200 text-gray-700 text-base font-normal py-4">
            {#each spareParts as sp, i}
              {#if sp.parent === p.ProductNo + p.Cfid}

                <div class="flex flex-wrap md:flex-nowrap items-center pl-10 py-4 md:py-1 relative">

                  <div class="bg-white mr-6 thumb flex-shrink-0" style="width: 20px; height: 20px;">
                    <img src={imgURL + sp.ThumbName} class="object-contain" />
                  </div>
                  <div class="bg-white h-56 w-56 hide">
                    <img src={imgURL + sp.ThumbNameZoom} class="object-contain" />
                  </div>

                  <div class="w-auto pr-5 md:w-1/6 text-left">{sp.SparePartNo}</div>

<!--                  <div class="w-32 text-base text-center font-light pr-6">&nbsp;</div>-->

                  <div class="flex-grow text-left py-3 ">{sp.SparePartName}</div>
                  <div class="flex-shrink-0 text-red-500 py-3 px-6 lg:px-10">{sp.Recommended ? 'Recommended' : ' '}</div>

                  <div class="w-full md:w-auto flex justify-right flex-shrink-0 mt-2">
                    <div class="flex-shrink-0 bg-white rounded px-5">
                      <AddToCart bind:sp={spareParts[i]} on:change={(e) => { dispatch('add_to_cart', e.detail) }} />
                    </div>
                  </div>

                  <div class="w-4 lg:w-16 flex-shrink-0">&nbsp</div>

                </div>
              {/if}
            {/each}
          </div>
        {/if}

      </div>

    {/each}
  {/if}
</div>

<style>
    .hide {
        display: none;
        position: absolute;
        top: 10px;
        left: 90px;
        /*background-color: #f2f2f2;*/
        opacity: 0.9;
    }

    .thumb {
        z-index: 20;
    }

    .row {
        position: relative;
    }

    .thumb:hover + .hide {
        display: block;
        z-index: 10;
    }
</style>